import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderCardContext } from '../../../../../contexts/card/cardOrder/context';
import { mainCardTypes, orderCardFlowScreens } from '../../../constants';
import { Button } from '../../../../../components';
import ModalBodyLayout from '../partials/MainBodyLayout';
import RadioItem from '../../../../../components/RadioItem';

const CardType = () => {
  const { t: translate } = useTranslation();

  const { state, openScreen, updateCardType } = useContext(OrderCardContext);

  const cardOptions = state?.cardOptions;

  // card type here has the card provider value (monavate, galileo)
  const cardType = state?.cardType;

  const renderFooter = () => (
    <div className="btn-container">
      <Button
        variant="primary"
        disabled={!cardType}
        onClick={() => {
          openScreen(orderCardFlowScreens.CONFIRM_DETAILS);
        }}
        className="w-100">
        {translate('continue_btn_title')}
      </Button>
    </div>
  );

  const options = useMemo(() => {
    if (cardType && cardOptions && cardType in cardOptions) {
      return cardOptions[cardType].filter(
        (item) => item.type === mainCardTypes.PHYSICAL.toUpperCase()
      );
    }

    return [];
  }, [cardOptions, cardType]);

  return (
    <ModalBodyLayout
      withBack
      onPrevClick={() => openScreen(orderCardFlowScreens.FREE_CARD_PROMO)}
      title={translate('order_card_type_title')}>
      <div className="mt-4">
        <p className="text-f5 text-dark p-0">{translate('order_card_type_subtitle')}</p>
      </div>
      {options.map((item) => (
        <div key={item.name}>
          <RadioItem
            className="py-4 text-capitalize"
            label={
              item.name === 'visa' ? translate('card_order_confirm_visacard_title') : item.name
            }
            name="cardType"
            image={item.image}
            onChange={() => updateCardType(item.provider)}
            checked={cardType === item.provider}
          />
        </div>
      ))}
      {renderFooter()}
    </ModalBodyLayout>
  );
};

export default CardType;
